import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuth)?_c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VRow,{staticClass:"justify-center"},[_c(VCol,{attrs:{"cols":"12","md":"8","sm":"6"}},[_c('password-form-invira',{attrs:{"me":_vm.me},on:{"success":_vm.redirectToHome}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }